import { css } from "@emotion/react";

export const containerStyle = css`
  display: flex;
  align-items: start;
  justify-content: space-between;

  height: 32px;
  margin-right: 27px;
  margin-left: 24px;
  margin-top: 50px;

  @media only screen and (max-width: 992px) {
    display: none;
  }
`;

export const collapsedContainerStyle = css`
  display: flex;
  align-items: start;
  justify-content: center;

  height: 32px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 50px;

  @media only screen and (max-width: 992px) {
    display: none;
  }
`;

export const logoImageStyle = css`
  height: 60px;
`;
